var map = {
	"./Sample_Formatting_After.png": 605,
	"./Sample_Formatting_Before.png": 606,
	"./Sample_Outline.png": 607,
	"./Sample_Proofreading_and_formattingAfter.png": 608,
	"./Sample_Proofreading_and_formatting_Before.png": 609,
	"./Sample_Sources.png": 610,
	"./before_after_1.png": 611,
	"./before_after_cut.png": 612,
	"./icons.svg": 75,
	"./micro-1.svg": 613,
	"./micro-2.svg": 614,
	"./micro-3.svg": 615,
	"./preview1.png": 616,
	"./preview2.png": 617,
	"./preview3.png": 618,
	"./preview4.png": 619,
	"./preview5.png": 620,
	"./preview6.png": 621,
	"./services-img1.svg": 622,
	"./services-img2.svg": 623,
	"./services-img3.svg": 624,
	"./services-img4.svg": 625,
	"./source/pdf-icon.svg": 626,
	"./source/zoom-icon.svg": 627
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 604;